import { withAuthUser } from 'next-firebase-auth'
import * as Page from 'views/terms-of-service'

export const getStaticProps = Page.getStaticProps

export default withAuthUser<Page.TermsOfServicePageProps>()(Page.TermsOfService)
